import MongoService from './mongo.service'
import { store } from '../store'
import UserRoles from '../configs/user-roles.json'
import { getProp, isObject } from '../libs/utils'
import axios from 'axios'
import jwt from 'jsonwebtoken'
import GoogleAuth from '../plugins/google-auth'

const {
  VUE_APP_AUTHORIZER_URL: AUTHORIZER_URL,
  VUE_APP_AUTHORIZER_API_KEY: AUTHORIZER_API_KEY
} = process.env

export default {
  ROLES: UserRoles,
  // async init () {
  //   await this.getUser()
  // },
  async isLoggedIn () {
    const user = await this.getUser()
    return user && !!await this.getAccessToken()
  },
  async getAccessToken () {
    return store.state.user.accessToken
  },
  async getApiToken () {
    return store.state.user.apiToken
  },
  async checkAccessToken () {
    return await MongoService.checkAccessToken()
  },
  async login () {
    let jwtObject = {}
    let apiKey = ''
    let jwtToken = ''
    const googleResponse = await GoogleAuth.signIn()
    const googleUserAuth = googleResponse.getAuthResponse()
    const { 'id_token': idToken } = googleUserAuth
    const token = idToken
    try {
      const { result } = await axios.post(`${AUTHORIZER_URL}/login`, { token }, {
        headers: {
          'X-Api-Key': AUTHORIZER_API_KEY
        }
      }).then(r => r.data)
      if (result['error']) {
        throw new Error(result['error'])
      }
      apiKey = result['apiKey']
      jwtToken = result['jwt']
      jwtObject = jwt.decode(jwtToken)
      // console.log('jwt', jwtObject)
    } catch (e) {
      const error = (e.response && e.response.data.error) || e.message
      console.log('login', error)
      console.log('jwt', false)
      await this.logout()
      throw new Error(error)
    }
    let userRole = UserRoles[jwtObject['role']] || UserRoles['GUEST']
    let state = {
      // FIXME: Change this
      user: {
        name: jwtObject.name,
        role: userRole.name,
        picture: jwtObject.picture
      },
      accessToken: jwtToken,
      apiToken: apiKey
    }
    await store.dispatch('user/setState', state)
    console.log('login', state)
    return state
  },
  async logout () {
    await Promise.all([
      GoogleAuth.signOut(),
      store.dispatch('user/resetState')
    ])
    // console.log('logout', await this.getUser())
  },
  async getUser () {
    const user = await store.getters['user/user']
    // console.log('getUser', user)
    return user
  },
  hasPermission (permissionName = '', permissionProp = '') {
    if (!permissionName) return true
    const role = store.getters['user/role']
    if (!role) return false
    if (role.permissions === true) return true
    const permission = role.permissions[permissionName]
    if (isObject(permission) && permissionProp !== '') {
      const defaultAuthorize = getProp(permission, '_default', false)
      let authorized = getProp(permission, permissionProp)
      if (authorized === undefined) {
        authorized = getProp({ [permissionProp.split('.')[0]]: defaultAuthorize }, permissionProp, defaultAuthorize)
      }
      console.log(permissionProp, authorized)
      return !!authorized
    }
    console.log(permissionProp, permission)
    return !!permission
  }
}
